import React from 'react';
import { Table, Button } from '../common';
import PortOpeningRequest from '../../models/entities/PortOpeningRequest';
import ProgressBarSmall from '../PortOpeningRequests/components/ProgressBarSmall';
import { useNavigate } from 'react-router-dom';
import './ApprovalsPORsTableRow.css';

interface ApprovalsPORsTableRowProps {
    por: PortOpeningRequest;
}

const ApprovalsPORsTableRow = ({ por }: ApprovalsPORsTableRowProps) => {
    const navigate = useNavigate();
    const handleViewDetails = () => {
        navigate(`/subscriptions/${por.subscriptionRequestId}/portOpeningRequests/${por.id}`);
    };

    return (
        <Table.Row>
            <Table.Cell>
                #{por.id}
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center'>
                {por.subscriptionRequestName}
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center center-align'>
                <ProgressBarSmall workflowState={por.workflowInstance.currentWorkflowInstanceState.workflowState} porScope={por.direction?.name} />
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center'>
                <Button style={{ width: 120, height: 34 }} onClick={handleViewDetails} variant="primary">
                    See Details
                </Button>
            </Table.Cell>
        </Table.Row>
    );
}

export default ApprovalsPORsTableRow;